import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import { ModalIdentifyFile } from "components/ModalIdentifyFile/ModalIdentifyFile";
import { Tooltip } from "components/Tooltip/Tooltip";
import { File as DrsFile } from "graphql/_Types";
import { useModalContext } from "providers/ModalProvider/ModalProvider";
import { getDrsFileModifyPermissionByDrsFileAndAction } from "types/DrsFileModifyPermissions";

export interface ButtonIdentifyFileProps {
  file: Pick<
    DrsFile,
    | "id"
    | "fileType"
    | "tags"
    | "processingStatus"
    | "source"
    | "fileFormat"
    | "originalName"
    | "isSeries"
    | "seriesParentId"
    | "status"
  >;
}
export const ButtonIdentifyFile = ({ file }: ButtonIdentifyFileProps) => {
  const { openModal, closeModal } = useModalContext();

  return (
    <>
      <Tooltip content={"Change Type"}>
        <ButtonIconPermissioned
          aria-label="Set file type"
          defaultTooltip={"Change file type"}
          requiredPermission="edit"
          color={"primary"}
          onClick={() =>
            openModal(<ModalIdentifyFile file={file} onClose={closeModal} />)
          }
          iconType="documentEdit"
          disabled={
            !getDrsFileModifyPermissionByDrsFileAndAction(file, "IDENTIFY")
              .isPermitted
          }
        />
      </Tooltip>
    </>
  );
};
